import { Reducer } from "redux";
import { AboutActionTypes } from "./actions";

export interface IAboutState {
    result: any;
    error: any;
    isFetching: boolean;
    lastFetched: number | null;
};

export const initialState: IAboutState = {
    result: {},
    error: '',
    isFetching: false,
    lastFetched: null,
};

const aboutReducer: Reducer<IAboutState> = (state = initialState, action): IAboutState => {
    switch (action.type) {
        case AboutActionTypes.GET_DATA_COUNTS: {
            return {
                ...state,
                isFetching: true,
            };
        }
        case AboutActionTypes.GET_DATA_COUNTS_SUCCESS: {
            return {
                ...state,
                result: action.payload,
                isFetching: false,
                lastFetched: Date.now(),
            };
        }
        case AboutActionTypes.GET_DATA_COUNTS_ERROR: {
            return {
                ...state,
                error: action.payload,
                isFetching: false,
            };
        }
        default:
            return state;
    }
};

export { aboutReducer };